module.exports = __webpack_public_path__ + "static/img/icon_notice.b92eabef.png";